import { Grid, Paper, Typography } from '@mui/material'
import { useFlags } from 'launchdarkly-react-client-sdk'
import React from 'react'
import { useAuth } from 'react-oidc-context'
import withAuthenticationRequired from '../auth/withAuthenticationRequired'

const Dashboard = () => {
  const { user } = useAuth()
  const { testFlag } = useFlags()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4} lg={3}>
        <Paper
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            height: 240,
          }}
        >
          <Typography component="h2" variant="h6" color="primary" gutterBottom>
            User Details
          </Typography>
          <Typography component="p">Name: {user?.profile.name}</Typography>
          <Typography component="p">Email: {user?.profile.email}</Typography>
        </Paper>
      </Grid>
      {testFlag && (
        <Grid item xs={12} md={4} lg={3}>
          <Paper
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              height: 240,
            }}
          >
            <Typography
              component="h2"
              variant="h6"
              color="primary"
              gutterBottom
            >
              Test Flag Enabled
            </Typography>
          </Paper>
        </Grid>
      )}
    </Grid>
  )
}

export default withAuthenticationRequired(Dashboard)
